import { lazy } from 'react';
import {  useSelector } from "react-redux";

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const CategoryDefault = Loadable(lazy(() => import('pages/category/default')));
const CategoryView = Loadable(lazy(() => import('pages/category/view')));
const ServiceDefault = Loadable(lazy(() => import('pages/services/default')));
const CouponDefault = Loadable(lazy(() => import('pages/coupon/default')));
const BookingDefault = Loadable(lazy(() => import('pages/booking/default')));
const VendorDefault = Loadable(lazy(() => import('pages/vendor/default')));
const ImportDefault = Loadable(lazy(() => import('pages/import/default')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));
const ErrorPage = Loadable(lazy(() => import('pages/extra-pages/error-page')));

// ==============================|| MAIN ROUTING ||============================== //

//const { authData, token } = useSelector((state) => state.auth);
const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  errorElement: <ErrorPage />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />,
    },
    {
      path: 'dashboard/*',
      element: <DashboardDefault />
    },
    {
      path: 'category/*',
      element: <CategoryDefault />
    },
    {
      path: 'category/view/:id',
      element: <CategoryView />
    },
    {
      path: 'service/*',
      element: <ServiceDefault />
    },
    {
      path: 'coupon/*',
      element: <CouponDefault />
    },
    {
      path: 'booking/*',
      element: <BookingDefault />
    },
    {
      path: 'vendor/*',
      element: <VendorDefault />
    },
    {
      path: 'import/*',
      element: <ImportDefault />
    },
    
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    }
  ]
};

export default MainRoutes;
